export const environment = {
  production: false,
  authServiceUrl: 'https://auth.zikata.africa/auth',
  authRealm: 'client',
  authClientId: 'clients-portal',
  authSuccessRedirectUrl: 'https://sms.zikata.africa',
  officerRoles: {
    ROLE_CLIENT: 'Client',
  },
  apiGatewayBaseUrl: 'https://api.zikata.africa/api/v1',
  apiGatewayV2BaseUrl: 'https://api.zikata.africa/api/v2',
  fbAccessToken: 'xx',
  phoneNumberId: 'xx',
};
